import { compose } from 'redux';

const reduxDevToolsExtensionCompose =
  process.env.NODE_ENV === 'development' && window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
export const composeEnhancers = reduxDevToolsExtensionCompose || compose;
